export default "__VITE_ASSET__B4zhP3e$__"